module.exports = __webpack_public_path__ + "static/media/index-shop-inv.a5c898ea.webp";